<template>
  <div>
    <div v-if="isLoading">
      <UtilPlaceholder v-for="index in 8" :key="index" class="h-24" :class="index < 8 ? 'mb-1' : ''" />
    </div>

    <UtilEmpty
      v-else-if="events.length === 0"
      :icon="faGavel"
      title="No upcoming auctions or events"
      message="Check back soon"
      targetClass="rounded text-gray-darker py-6 px-4 sm:px-8 w-full my-12"
    />

    <RouterLink
      v-else
      v-for="event in events"
      :key="event.auctionid"
      :to="`/events/${event.eventRef}`"
      class="auctions-list"
      :class="linkPadding"
    >
      <div v-if="showLogo" class="flex-shrink-0 mr-4 rounded-full h-20 w-20 overflow-hidden">
        <UtilImage :fileRef="event.avatarFileRef" cover showOriginal class="auctions-img" />
      </div>

      <div class="flex-grow">
        <span class="auctions-title">{{ event.name }}</span>

        <span class="auctions-description">
          <FontAwesomeIcon :icon="faCalendarAlt" class="mr-1" />
          {{ eventDateDisplay(event, true) }}
        </span>
      </div>

      <div class="flex-shrink ml-2">
        <FontAwesomeIcon :icon="faChevronRight" />
      </div>
    </RouterLink>
  </div>
</template>

<script>
import { faCalendarAlt, faGavel, faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import eventDateDisplay from '@/lib/event-date'
import UtilPlaceholder from '@/components/utils/placeholders/UtilPlaceholder'
import UtilImage from '@/components/utils/UtilImage'
import UtilEmpty from '@/components/utils/UtilEmpty'

export default {
  name: 'UtilEventsUpcoming',
  props: {
    isLoading: Boolean,
    events: Array,
    showLogo: {
      type: Boolean,
      default: true
    },
    linkPadding: {
      type: String,
      default: 'container-padding-x'
    }
  },
  components: {
    UtilPlaceholder,
    UtilImage,
    UtilEmpty
  },
  data() {
    return {
      eventDateDisplay,
      faCalendarAlt,
      faGavel,
      faChevronRight
    }
  }
}
</script>

<style lang="scss" scoped>
#app.smAndDown .auctions-banner {
  @apply rounded-none;
}

.auctions-list {
  @apply flex items-center py-2 border-b cursor-pointer;

  &:hover {
    @apply bg-gray-100;
  }

  .auctions-img {
    @apply h-full w-full;
  }

  .auctions-title {
    @apply block font-medium pr-4;
  }

  .auctions-description {
    @apply block text-sm text-gray-600;
  }
}
</style>
